export const SET_SETTINGS = "settings/SET_SETTINGS";
